/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var details = "";
  var hpnumber = "";
  var countdown = "";

  var scanqr = function scanqr() {
    window.qrcode = "";

    if (window.lat == undefined) {
      $f7.dialog.alert("Please enable GPS for this APP");
      return;
    }

    cordova.plugins.barcodeScanner.scan(function (result) {
      checkQr(result.text);
    }, function (error) {
      alert("Scanning failed: " + error);
    });
  };

  var checkQr = function checkQr(qrcode) {
    window.qrcode = qrcode;
    $f7.request({
      method: 'get',
      url: "https://vbs.gdlotto.tl/json/submit.aspx",
      data: {
        value: qrcode,
        latitude: window.lat,
        longitude: window.lot
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        data = JSON.parse(data);
        var swipeToClosePopup = $f7.popup.create({
          el: '.popup-otp',
          swipeToClose: true
        });
        clearInterval(window.interval);
        window.count = 0;
        window.interval = setInterval(function () {
          window.count++;
          if (window.count < 30) countdown = 30 - window.count + " sec to request new OTP";else countdown = "Please click <a href='#' class='otp-new' id='" + qrcode + "' style='color:#ff6666'> HERE </a> to request another OTP";
          $update();
        }, 1000);
        $('.num1').val('');
        $('.num2').val('');
        $('.num3').val('');
        $('.num4').val('');
        $('.num5').val('');
        $('.num6').val('');
        setTimeout(function () {
          $(".num1").focus();
        }, 1000);
        swipeToClosePopup.open();
        hpnumber = data.NUMBER;
        $update();
      }
    });
  };

  var submitOtp = function submitOtp() {
    if ($(".num1").val() == "") {
      $f7.dialog.alert("Please fill in 6 OTP numbers");
      return;
    }

    if ($(".num2").val() == "") {
      $f7.dialog.alert("Please fill in 6 OTP numbers");
      return;
    }

    if ($(".num3").val() == "") {
      $f7.dialog.alert("Please fill in 6 OTP numbers");
      return;
    }

    if ($(".num4").val() == "") {
      $f7.dialog.alert("Please fill in 6 OTP numbers");
      return;
    }

    if ($(".num5").val() == "") {
      $f7.dialog.alert("Please fill in 6 OTP numbers");
      return;
    }

    if ($(".num6").val() == "") {
      $f7.dialog.alert("Please fill in 6 OTP numbers");
      return;
    }

    var otp = $(".num1").val() + "" + $(".num2").val() + "" + $(".num3").val() + "" + $(".num4").val() + "" + $(".num5").val() + "" + $(".num6").val();
    verify(window.qrcode, otp);
  };

  var verify = function verify(qrcode, otp) {
    $f7.request({
      method: 'get',
      url: "https://vbs.gdlotto.tl/json/decrypt.aspx",
      data: {
        value: qrcode,
        code: otp,
        latitude: window.lat,
        longitude: window.lot
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        details = "";
        $update();
        var swipeToClosePopup = $f7.popup.create({
          el: '.popup-about',
          swipeToClose: true
        });
        data = JSON.parse(data);

        if (data.STATUS == "1") {
          //var data = `{"STATUS":"1","DETAILS":[{"TYPE":"LOGIN","VALUE":"67077865228"},{"TYPE":"NAME","VALUE":"EGIPTO GUTERRES F AMARAL"},{"TYPE":"ID","VALUE":"06020409109597704"},{"TYPE":"LOCATION","VALUE":"DILI"}]}`;
          for (var i = 0; i < data.DETAILS.length; i++) {
            details += "\n            <tr>\n              <td class=\"label-cell\" style=\"color:#C70039;\">" + data.DETAILS[i].TYPE + "</td>\n              <td class=\"label-cell\">" + data.DETAILS[i].VALUE + "</td>\n            </tr>\n            ";
          }

          $update();
          var swipeToClosePopupOtp = $f7.popup.create({
            el: '.popup-otp',
            swipeToClose: true
          });
          swipeToClosePopupOtp.close();
          swipeToClosePopup.open();

          if (data.ALERT != "" && data.ALERT != null) {
            $f7.dialog.alert(data.ALERT);
          }
        } else {
          $('.num1').val('');
          $('.num2').val('');
          $('.num3').val('');
          $('.num4').val('');
          $('.num5').val('');
          $('.num6').val(''); //$f7.dialog.alert("Error: " + data.DETAILS,"Verification Failed");

          $f7.dialog.alert("<center><img src='static/images/warning.png' width='100px'/><p>Verification failed or OTP number is wrong. Please try again.</p></center>", "Failed", function () {
            $(".num1").focus();
          });
        }
      }
    });
  };

  $on('pageInit', function () {
    $(document).on("click", ".otp-new", function (e) {
      window.orderId = e.srcElement.id;
      console.log(window.orderId);
      checkQr(e.srcElement.id);
    });
    var swipeToClosePopup = $f7.popup.create({
      el: '.popup-gps',
      swipeToClose: true
    });
    swipeToClosePopup.open();
    window.lat = localStorage.getItem("lat");
    window.lot = localStorage.getItem("lot");
    $('.num1').keyup(function (e) {
      $('.num2').focus();
      $('.num2').val('');
    });
    $('.num2').keyup(function (e) {
      $('.num3').focus();
      $('.num3').val('');
    });
    $('.num3').keyup(function (e) {
      $('.num4').focus();
      $('.num4').val('');
    });
    $('.num4').keyup(function (e) {
      $('.num5').focus();
      $('.num5').val('');
    });
    $('.num5').keyup(function (e) {
      $('.num6').focus();
      $('.num6').val('');
    });
    $('.num6').keyup(function (e) {
      $('.num6').blur();
    });
    $('.num1').click(function (e) {
      $('.num1').val('');
    });
    $('.num2').click(function (e) {
      $('.num2').val('');
    });
    $('.num3').click(function (e) {
      $('.num3').val('');
    });
    $('.num4').click(function (e) {
      $('.num4').val('');
    });
    $('.num5').click(function (e) {
      $('.num5').val('');
    });
    $('.num6').click(function (e) {
      $('.num6').val('');
    }); //checkQr("A49p9U6VfqMR/qHf7Kw2qQqwJQTb26e77L1X091DO8vEPLwmx/aoy3h82RWhdTxiMldayQ77YtE=");

    setInterval(function () {
      if ($(".button-scan").html() != "[     SCAN     ]") {
        $(".button-scan").html("[     SCAN     ]");
      } else {
        $(".button-scan").html("SCAN");
      }

      if (window.lat != undefined) {
        swipeToClosePopup.close();
      }
    }, 1000);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="home">

    <!-- Top Navbar -->
    <div class="navbar navbar-transparent">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <!-- <div class="left">
          <a href="#" class="link icon-only panel-open" data-panel="left">
            <i class="icon f7-icons">chevron_left</i>
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div> -->                                                                                                                 
        <div class="title sliding">GD Lotaria</div>
        
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content">

      <!--div style="background-image: url('static/images/longlong.png'); background-repeat: no-repeat;background-size: cover;background-color: var(--f7-theme-color); height: 250px; margin-top: -150px; border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;">
 
      </div-->
      <div style="background-image: url('static/images/bg5.jpeg'); background-repeat: no-repeat;background-size: cover;background-color: var(--f7-theme-color); height: 250px; margin-top: -150px; border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;">
 
      </div>
      <div style="color: white; margin-top: -135px;" >
        <table  width="100%"> 
          <td width=10px>

          </td>
          <td width=80px>
            <img src="static/images/gd.png" width=90px style="vertical-align: middle;"/>
          </td>
          <td width=10px>

          </td>
          <td>
            <H2 style="position:relative; top:-5px">
              GD Lotaria
            </H2>
            <span style="font-size:16px;position:relative; top:-25px">
              Authority Verification
            </span>
          </td>
          <td width=80px style="text-align: center;">
            <img src="static/images/tl-logo4.png" width=80px style="vertical-align: middle;"/>
          </td>
          <td width=10px>

          </td>
        </table>
      </div>

      <div class='.auth'>

      </div>
      
      <div class="block" style="text-align: center;">
        <br/><br/>
        <H2>
          AGENT CARD SCANNER
        </H2>
        <p>
          Please scan the agent card QR for verification
        </p>
        <img src='static/images/qr-scan.png' width='200px' style="margin-left:40px" @click=${scanqr}/>
        <br/>
        <br/>
        <br/>
        <div class="block">
          <div class="block">
            <button class="button button-fill button-large button-round button-scan" @click=${scanqr} style="font-size: x-large;">SCAN</button>
          </div>
        </div>
        
      </div>
    </div>

    <div class="popup popup-otp">
      <div class="block" style="text-align: right;">
        <a href="#" class="link icon-only popup-close">
          <i class="icon f7-icons">multiply_circle</i> 
        </a>
      </div>

      <div class="block">
        <H2>OTP Verification</H2>
        <h4>
          Agent's registered number <span style="font-size:larger;color:lightblue">(<span innerHTML=${hpnumber}></span>)</span> will receive the OTP. Please kindly enter the OTP into the text box and click "Submit"
        </h4>
      </div>
      
      <div class="list block no-hairlines no-hairlines-between" >
        <ul>

          <!-- additional "item-input-outline" class -->
          <li class="item-content item-input item-input-outline no-hairlines-between" style="background-color: black;" >
            <div class="item-inner">
              <div class="row">
                <div class="col">
                   <div class="item-input-wrap">
                    <input type="number" pattern="\\d*" max="1" style="width: 100%;text-align: center;height: 70px; font-size:x-large;" id="1" name="1" class="num1"/>
                    
                  </div>
                </div>
                <div class="col">
                  <div class="item-input-wrap">
                    <input type="number" pattern="\\d*" max="1" style="width: 100%;text-align: center;height: 70px;  font-size:x-large;" id="2" name="2" class="num2"/>
                   
                 </div>
                </div>
                <div class="col">
                  <div class="item-input-wrap">
                    <input type="number" pattern="\\d*" max="1" style="width: 100%;text-align: center;height: 70px; font-size:x-large;" id="3" name="3" class="num3"/>
                   
                 </div>
                </div>
                <div class="col">
                  <div class="item-input-wrap">
                    <input type="number" pattern="\\d*" max="1" style="width: 100%;text-align: center;height: 70px;  font-size:x-large;" id="4" name="4" class="num4"/>
                   
                 </div>
                </div>
                <div class="col">
                  <div class="item-input-wrap">
                    <input type="number" pattern="\\d*" max="1" style="width: 100%;text-align: center;height: 70px;  font-size:x-large;" id="5" name="5" class="num5"/>
                   
                 </div>
                </div>
                <div class="col">
                  <div class="item-input-wrap">
                    <input type="number" pattern="\\d*" max="1" style="width: 100%;text-align: center;height: 70px;  font-size:x-large;" id="6" name="6" class="num6"/>
                   
                 </div>
                </div>
              </div>

              
            </div>
          </li>

        </ul>
      </div>
    
      <div class="block">
        <div class="block">
          <a class="button button-fill button-large button-round" href="#" @click="${submitOtp}" style="font-size: x-large;">SUBMIT</a>
        </div>
      </div>
      <div class="block" style="text-align: center;" innerHTML="${countdown}">
      20 sec to request new OTP
      </div>
    </div>

    <div class="popup popup-about">
      <div class="block">
        <H3>Verification Success</H3>
        <p>
          The agent card is active and verified
        </p>
      </div>
      <div class="card data-table">
        <table>
          <tbody innerHTML=${details}>

          </tbody>
        </table>
      </div>
      <div style="text-align: center;">
        <img src="static/images/sign.png" width="100px"/>
      </div>
      <div class="block">
      <a class="link popup-close button button-fill button-large button-round" href="#">CLOSE</a>
      </div>
    </div>

    <div class="popup popup-gps" style="background-color: white;">
      <br/>
      <br/><br/><br/><br/>
      <div style="text-align: center;color: black;">
        <img src="static/images/gps.gif" width="100%"/>
        <p>
          <h3>
            Please Wait...
          </h3>
        </p>
        <p>
          Finding your location using GPS
        </p>
      </div>
    </div>

  </div>  
`
    }
    ;
}

framework7Component.id = '6645c2ddb6';
export default framework7Component;